import React from 'react';
import { Row, Col, InputNumber } from 'antd';
import Text from '../../../basicElement/Text';
import format from '../../../shared/format';
import { SmallToBig } from '../../../shared/formatElem'; 
import { getMatchOption } from '../../../shared/selectFn';

function MyInputNumber({ value, width, onChange }) {
    return (
        <InputNumber
            maxLength="17"
            precision={2}
            max={99999999999}
            style={{ width }}
            placeholder="请输入"
            value={value}
            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\￥\s?|(,*)/g, '')}
            onChange={onChange}
        />
    );
}

function ContractAmount(props) {
    const { data, width, asterisk, currencyList, onChange } = props;
    const {
        currencyExchangeRateId, exchangeRate,
        jdeContractAmount, jdeActualExpenseFee, jdeActualFee, jdeContractFee
    } = data;
    const { currencyCode, currencyName } = getMatchOption(currencyList, 'currencyExchangeRateId', currencyExchangeRateId);
    const isCNY = currencyCode === 'CNY';

    let rate = '';
    if ((jdeContractFee || jdeContractFee === 0) && (jdeContractAmount || jdeContractAmount === 0)) {
        if (jdeContractAmount - jdeContractFee == 0) {
            rate = jdeContractAmount === 0 ? 0 : 100;
        } else {
            rate = jdeContractFee / (jdeContractAmount - jdeContractFee) * 100;
            rate = Number.isNaN(rate) ? '' : myFixed(rate,2);
        }
    }
    function myFixed(num, digit) {
        if(Object.is(parseFloat(num), NaN)) {
        return console.log(`传入的值：${num}不是一个数字`);
        }
        num = parseFloat(num);
        return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit);
    }

    return (
        isCNY ?
            <Row className="contractAmount">
                <Row>
                    <Col span={12}>
                        <Col span={8}><Text asterisk={asterisk} colon={true}>合同额含税/人民币</Text></Col>
                        <Col span={15} offset={1}>
                            <MyInputNumber
                                width={width}
                                value={jdeContractAmount}
                                onChange={value => onChange(value, 'jdeContractAmount')}
                            />
                            &nbsp;元
                            <SmallToBig value={jdeContractAmount} />
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Col span={8}><Text colon={true}>合同税率</Text></Col>
                        <Col span={15} offset={1}>{rate} %</Col>
                    </Col>
                </Row>
                <Row>
                    <Row>
                        <Col span={2} className="fill border-top border-left border-right">&nbsp;</Col>
                        <Col span={11} offset={2} className="border-top border-right">
                            <Col span={8}><Text colon={true}>实报实销(不含税)/人民币</Text></Col>
                            <Col span={15} offset={1}>
                                <MyInputNumber
                                    width={width}
                                    value={jdeActualExpenseFee}
                                    onChange={value => onChange(value, 'jdeActualExpenseFee')}
                                />
                                &nbsp;元
                                <SmallToBig value={jdeActualExpenseFee} />
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={2} className="fill flex-center border-left border-right">其中需扣除</Col>
                        <Col span={11} offset={2} className="border-right">
                            <Col span={8}><Text colon={true}>实报实销税费/人民币</Text></Col>
                            <Col span={15} offset={1}>
                                <MyInputNumber
                                    width={width}
                                    value={jdeActualFee}
                                    onChange={value => onChange(value, 'jdeActualFee')}
                                />
                                &nbsp;元
                                <SmallToBig value={jdeActualFee} />
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={2} className="fill border-left border-bottom border-right">&nbsp;</Col>
                        <Col span={11} offset={2} className="border-right border-bottom">
                            <Col span={8}><Text asterisk={asterisk} colon={true}>合同额税费/人民币</Text></Col>
                            <Col span={15} offset={1}>
                                <MyInputNumber
                                    width={width}
                                    value={jdeContractFee}
                                    onChange={value => onChange(value, 'jdeContractFee')}
                                />
                                &nbsp;元
                                <SmallToBig value={jdeContractFee} />
                            </Col>
                        </Col>
                    </Row>
                </Row>
            </Row>
        :
            <Row className="contractAmount">
                <Row>
                    <Col span={2} className="border-top border-left">&nbsp;</Col>
                    <Col span={11} className="border-top border-right">
                        <Col span={8} className="border-right">
                            <Text asterisk={asterisk}>合同额含税/原币&nbsp;</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <MyInputNumber
                                width={width}
                                value={jdeContractAmount}
                                onChange={value => onChange(value, 'jdeContractAmount')}
                            />
                            &nbsp;{currencyName}
                        </Col>
                    </Col>
                    <Col span={11} className="border-top border-right">
                        <Col span={8} className="border-right">
                            <Text>合同额含税/人民币&nbsp;</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            {format('money', jdeContractAmount, exchangeRate)}&nbsp;元
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={2} className="border-top border-left border-right">&nbsp;</Col>
                    <Col span={11} className="border-top border-right">
                        <Col span={8} className="border-right">
                            <Text>实报实销(不含税)/原币&nbsp;</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <MyInputNumber
                                width={width}
                                value={jdeActualExpenseFee}
                                onChange={value => onChange(value, 'jdeActualExpenseFee')}
                            />
                            &nbsp;{currencyName}
                        </Col>
                    </Col>
                    <Col span={11} className="border-top border-right">
                        <Col span={8} className="border-right">
                            <Text>实报实销(不含税)/人民币&nbsp;</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            {format('money', jdeActualExpenseFee, exchangeRate)}&nbsp;元
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={2} className="border-left border-right" style={{ textAlign: 'center' }}>其中需扣除</Col>
                    <Col span={11} className="border-top border-right">
                        <Col span={8} className="border-right">
                            <Text>实报实销税费/原币&nbsp;</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <MyInputNumber
                                width={width}
                                value={jdeActualFee}
                                onChange={value => onChange(value, 'jdeActualFee')}
                            />
                            &nbsp;{currencyName}
                        </Col>
                    </Col>
                    <Col span={11} className="border-top border-right">
                        <Col span={8} className="border-right">
                            <Text>实报实销税费/人民币&nbsp;</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            {format('money', jdeActualFee, exchangeRate)}&nbsp;元
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={2} className="border-left border-right">&nbsp;</Col>
                    <Col span={11} className="border-top border-right">
                        <Col span={8} className="border-right">
                            <Text asterisk={asterisk}>合同额税费/原币&nbsp;</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <MyInputNumber
                                width={width}
                                value={jdeContractFee}
                                onChange={value => onChange(value, 'jdeContractFee')}
                            />
                            &nbsp;{currencyName}
                        </Col>
                    </Col>
                    <Col span={11} className="border-top border-right">
                        <Col span={8} className="border-right">
                            <Text>合同额税费/人民币&nbsp;</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            {format('money', jdeContractFee, exchangeRate)}&nbsp;元
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={2} className="border-top border-left border-bottom">&nbsp;</Col>
                    <Col span={11} className="border-top border-bottom">
                        <Col span={8} className="border-right">
                            <Text>合同税率&nbsp;</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            {rate}&nbsp;%
                        </Col>
                    </Col>
                    <Col span={11} className="border-top border-right border-bottom">&nbsp;</Col>
                </Row>
            </Row>
    );
}

export default ContractAmount;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/ContractAmount.js